import mixitup from 'mixitup';
import mixitupPagination from './mixitup-pagination';

mixitup.use(mixitupPagination);

$(document).ready(function() {
    $('.downloads-and-links-pdf').each(function() {
        mixitup(this, {
            pagination: {
                limit: 8
            }
        });
    });
});
